import axios from 'axios';
import { extend } from 'vee-validate';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import App from './App.vue';
import routes from "./routes";
import store from "./store";
import ApiService from "./utils/api.service";

import vuetify from "./plugins/vuetify"

Vue.use(VueAxios, axios)

Vue.use(Vuex)

Vue.use(VueRouter)

extend('required', {
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true
});


// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode:"history",
  linkExactActiveClass: "nav-item active"
});

// Ensure we checked auth before each page load.
router.beforeEach((to, _from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch("auth/check_auth")
    .then(() => {
      if (store.getters["auth/isAuthenticated"]) {
          next();
      } else {
        next({
          path: "/login"
        });
      }
    })
    .catch(() => {
      next({
        path: "/login"
      });
    })
  }else {
    next();
  }
});


ApiService.init();



Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
  store,
  vuetify
}).$mount('#app')
